export class Tabs {
    constructor(container) {
        this.container = container;

        if (this.container) {
            this.buttons = this.container.querySelectorAll('button');
            this.content = this.container.querySelectorAll('.content');

            this.init();
        }
    }

    init() {
        this.clickHandler();
    }

    clickHandler() {
        this.buttons.forEach( btn => {
            const value = btn.dataset.categoryBtn;

            btn.addEventListener('click', () => {
                this.removeActiveClasses(this.buttons);
                this.showContent(value);
                btn.classList.add('active');
            })
        })
    }

    showContent(btnValue) {
        this.content.forEach( content => {
            const key = content.dataset.key;

            if (btnValue == key) {
                content.classList.remove('hidden');
            } else {
                content.classList.add('hidden');
            }
        })
    }

    removeActiveClasses(array) {
        return [...array].map( btn => btn.classList.remove('active') );
    }

}

// ..........BUILDER COMPONENTS TABS

export class ComponentsTabs extends Tabs {
    constructor(container) {
        super(container)
    }

    showContent(btnValue) {
        const features = this.container.querySelectorAll('.feature');

        features.forEach( feature => {
            const key = feature.dataset.key;

            if (btnValue == key) {
                feature.classList.remove('hidden');
                feature.classList.add('flex');
            } else {
                feature.classList.remove('flex');
                feature.classList.add('hidden');
            }
        })
    }
}

export class TeamTabs extends Tabs {
    constructor(container) {
        super(container)

        this.duration = 200
    }

    showContent(btnValue) {
        this.content.forEach( content => {
            const key = content.dataset.key;

            if (btnValue == key) {
                content.classList.remove('closed');
                setTimeout( () => {
                    content.classList.remove('hidden');
                    content.classList.add('opened')
                }, this.duration)
            } else {
                setTimeout( () => content.classList.add('hidden'), this.duration)
                content.classList.add('closed');
                content.classList.remove('opened');
            }
        })
    }
}
